module.exports = __webpack_public_path__ + "static/media/18ECA6.57e24023.jpg";